import { Component, ElementRef, Inject, Input, OnDestroy, OnInit, ViewChild, } from '@angular/core';
import { MatLegacyDialog as MatDialog, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DepotService, AssetTypeClassification, LocationTypeDto, CurrentAssetLocationDto, CustomerLocationDto, CustomerDetailsService, CustomerDetailsResponse, ContainerStatus, ContainerAvailabilityShow, LocationDetailsService, ContainerPositionDto, LocationService, JobService, JobBasicDto } from 'src/shared/service-proxies/service-proxies';
import { PageHelperService } from '../helpers/page-helper.service';
import { PagebaseComponent } from '../pagebase/pagebase.component';
import { ApplicationStatusService } from '../services/application-status.service';
import * as moment from 'moment';
import { SessionStorageService } from '../services/session-storage.service';
import { Router } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { VehicleTypeHelper } from '../helpers/VehicleTypeHelper';
import { LocalStorageService } from '../services/local-storage.service';
import { CustomerSettings } from '../services/customer-settings-service';
import { Observable, of } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { forEach } from '@angular-devkit/schematics';
import { AuthService } from '../security/auth.service';
import { SummaryDataItemModel } from '../models/summary-data-item-model';
import { PagingModel } from '../widgets/models/paging-model';

export class DropDownListItem {
  constructor(id?: string, name?: string) {
    this.id = id,
    this.name = name;
  }

  id: string;
  name: string;
}

export enum DamageStatus {
  None = 0,
  InService = 1,
  Damaged = 2,
  DamagedInService = 3
}

export enum ShowSetting {
  All = 0,
  Surplus = 1,
  Deficit = 2
}

export enum DamageContainerStatus {
  InService = 0,
  Damaged = 1,
  DamagedInService = 2
}

@Component({
  selector: 'app-customer-details-component',
  templateUrl: './customer-details.component.html',
  styleUrls: ['./customer-details.component.scss']
})
export class CustomerDetailsComponent extends PagebaseComponent implements OnDestroy, OnInit {
  @Input() locationId!: string;
    
  // Private variables
  customerId: string;
  data: CustomerDetailsResponse;
  regionList: DropDownListItem[] = [];
  allDepots: DropDownListItem[] = [];
  depotList: DropDownListItem[] = [];
  allLocations: DropDownListItem[] = [];
  locationList: DropDownListItem[] = [];
  selectedRegionId: string;
  selectedDepotId: string;
  selectedLocationId: string = null;
  selectedVehicleType: string;
  selectedDamageStatus: string;
  selectedShowSetting: string;
  currentFilter: string;
  assetTypeSearchControl: UntypedFormControl = new UntypedFormControl();
  expandedCategories: string[] = [];
  searchControl: UntypedFormControl = new UntypedFormControl();
  locationTypes: LocationTypeDto[];
  locationTypesDisplay: LocationTypeDto[] = [];  
  summaryData = [];
  locations: CustomerLocationDto[];
  totalDepot: number = 0;
  totalYard: number = 0;
  totalDamaged: number = 0;
  totalAvailable: number = 0;
  totalRequired: number = 0;
  totalSurplus: number = 0;
  totalDeficit: number = 0;
  totalNetSurplus: number = 0;
  jobsPaging: PagingModel;
  jobsPage: number = 1;
  private apiCall;

  // Public variables
  DamageStatus = DamageStatus;
  ShowSetting = ShowSetting;
  loading: boolean = true;
  containersLoaded: boolean = false;
  filtersLoaded: boolean = false;
  dataLoaded: boolean = false;
  isAdmin: boolean = false;
  containers: ContainerPositionDto[] = [];
  location: CustomerLocationDto;
  jobs: JobBasicDto[];
  
  // Constuctor
  constructor(
    private customerDetailsService: CustomerDetailsService,
    private depotService: DepotService,
    private locationService: LocationService,
    private locationDetailsService: LocationDetailsService,
    private jobService: JobService,
    private sessionStorageService: SessionStorageService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private customerSettings: CustomerSettings,
    private authService: AuthService,
    pageHelperService: PageHelperService,
    applicationStatusService: ApplicationStatusService
    ) {
    super(pageHelperService, applicationStatusService, customerSettings, "Customer");

    if (this.locationId) {
      this.sessionStorageService.setItem("location-selectedLocationId", this.locationId);
      this.sessionStorageService.removeItem("location-selectedRegionId");
      this.sessionStorageService.removeItem("location-selectedDepotId");
      this.sessionStorageService.removeItem("location-selectedDamageStatus");
      this.sessionStorageService.removeItem("location-selectedShowSetting");
    }
  }

  ngOnInit() {
    this.authService.isAdmin().then(result => {
      this.isAdmin = result;
    })
    this.summaryData = this.getLoadingSummarries();
  }

  ngOnDestroy(): void {
  }

  getLoadingSummarries() : SummaryDataItemModel[] {
    var items = [];
    var text = "";
    text = text.concat("\xa0");
    let blank: SummaryDataItemModel = {
      Title: text,
      Value: text
    };
    items.push(blank);
    items.push(blank);
    items.push(blank);
    items.push(blank);
    return items;
  }

  unsubscribe() { 
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }
  }

  reset() {
    this.data = null;
    this.locations = [];
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }
  }

  // Get the view data
  async getData() {
    this.data = null;
    this.loading = true;

    this.setIsLoading(this.loading);

    this.filtersLoaded = false;
    this.dataLoaded = false;

    if (this.locationId) {
      this.sessionStorageService.setItem("location-selectedLocationId", this.locationId);
    }

    let selectedRegionId = this.sessionStorageService.getItem("location-selectedRegionId");
    if(selectedRegionId) {
      this.selectedRegionId = selectedRegionId;
    }
    else {
      this.selectedRegionId = null;
    }
    let selectedDepotId = this.sessionStorageService.getItem("location-selectedDepotId");
    if(selectedDepotId) {
      this.selectedDepotId = selectedDepotId;
    }
    else {
      this.selectedDepotId = null;
    }
    let selectedLocationId = this.sessionStorageService.getItem("location-selectedLocationId");
    if(selectedLocationId) {
      this.selectedLocationId = selectedLocationId;
    }
    else {
      this.selectedLocationId = null;
    }
    let selectedVehicleType = this.sessionStorageService.getItem("dashboard-active-selectedVehicleType");
    if(selectedVehicleType) {
      selectedVehicleType = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedVehicleType"));
      this.selectedVehicleType = selectedVehicleType;
    }
    let selectedDamageStatus = this.sessionStorageService.getItem("location-selectedDamageStatus");
    if(selectedDamageStatus) {
      this.selectedDamageStatus = selectedDamageStatus;
    }    
    let selectedShowSetting = this.sessionStorageService.getItem("location-selectedShowSetting");
    if(selectedShowSetting) {
      this.selectedShowSetting = selectedShowSetting;
    }
    
    this.getContainers();

    if(this.customerId != this.pageHelperService.selectedCompanyId) {
      console.log("loading regions, depots & locations");

      this.customerId = this.pageHelperService.selectedCompanyId;
      this.depotService.getRegions(this.pageHelperService.selectedCompanyId).subscribe(data => {
        const regionList: DropDownListItem[] = [];
        data.forEach(region => {
          let regionItem = new DropDownListItem()
          regionItem.id = region.id;
          regionItem.name = region.name;
          regionList.push(regionItem)
        });
        
        this.regionList = regionList;
        this.depotService.getUserDepots(this.pageHelperService.selectedCompanyId).subscribe(data => {    
          const depotList: DropDownListItem[] = [];
          data.forEach(depot => {
            let depotItem = new DropDownListItem()
            depotItem.id = depot.id;
            depotItem.name = depot.name;
            depotList.push(depotItem)
          });
          
          this.allDepots = depotList;
          this.depotList = depotList;
          this.locationService.getActiveByCustomer(this.pageHelperService.selectedCompanyId).subscribe(locations => {    
            const locationList: DropDownListItem[] = [];
            locations.forEach(location => {
              let locationItem = new DropDownListItem()
              locationItem.id = location.id;
              locationItem.name = location.name;
              locationList.push(locationItem)

              if (location.id == this.selectedLocationId) {
                this.selectedDepotId = location.depotId;
              }
            });
            
            this.allLocations = locationList;
            this.locationList = locationList;
            this.filtersLoaded = true;
            if (this.containersLoaded && this.filtersLoaded && this.dataLoaded) {
              this.loading = false;
              this.setIsLoading(this.loading);
            }
          });
        });
      });
    }
    else {
      this.filtersLoaded = true;
      if (this.containersLoaded && this.filtersLoaded && this.dataLoaded) {
        this.loading = false;
        this.setIsLoading(this.loading);
      }
    }

    this.jobsPage = 1;
    this.apiCall = this.customerDetailsService
      .getCustomerDetails(
        this.customerId,
        this.getRegionId(selectedRegionId),
        this.getDepotId(selectedDepotId),
        this.getLocationId(selectedLocationId))
      .subscribe(data => {
        this.data = data;
        
        if (this.data.regionDepotIds && this.data.regionDepotIds.length > 0) {
          this.depotList = this.allDepots.filter(item => this.data.regionDepotIds.includes(item.id));
        }
        else {
          this.depotList = this.allDepots;
        }
        this.locations = data.locations;
        this.locationList = this.locations.map(l => <DropDownListItem>{ id: l.id, name: l.displayName });
        this.locationTypes = data.locationTypes;
        this.showAssets();
        this.dataLoaded = true;
        if (this.containersLoaded && this.filtersLoaded && this.dataLoaded) {
          this.loading = false;
          this.setIsLoading(this.loading);
        }
        this.getJobs();
      }, error => {
        debugger;
      });

      console.log("done")
  }

  private getContainers() {
    this.containersLoaded = false;

    if (this.selectedLocationId) {
      this.locationDetailsService.getLocationDetails(this.selectedLocationId, this.pageHelperService.selectedCompanyId, false).subscribe(data => {
        let locationName = data?.location?.displayName;
        this.pageHelperService.setPageTitle(locationName ?? "Customer");
        let containers = data.containerPositions?.filter(a =>
          ((!this.currentFilter || this.currentFilter == "Depot")
            || (this.currentFilter == "Yard" && a.isYardBin)
            || (this.currentFilter == "Damaged" && a.damagedDate && !a.responseDate)
            || (this.currentFilter == "Available" && !a.isYardBin && !(a.damagedDate && !a.responseDate)))
            && ((!this.selectedVehicleType || this.selectedVehicleType == "All")
              || (a.assetTypeClassification == AssetTypeClassification.RoRo && this.selectedVehicleType == "RoRo")
              || (a.assetTypeClassification == AssetTypeClassification.Skip && this.selectedVehicleType == "Chain Lift")))
          /*
          .sort(function (a, b) {
            return b.daysOnSite - a.daysOnSite;
          })*/;
        this.containers = containers;
        this.location = data?.location;
        this.containersLoaded = true;
        if (this.containersLoaded && this.filtersLoaded && this.dataLoaded) {
          this.loading = false;
          this.setIsLoading(this.loading);
        }
      });
    }
    else {
      this.containersLoaded = true;
      this.pageHelperService.setPageTitle("Customer");
      if (this.containersLoaded && this.filtersLoaded && this.dataLoaded) {
        this.loading = false;
        this.setIsLoading(this.loading);
      }
    }
  }

  jobsChangePage(self: any, page: number) {
    self.jobsPage = page;
    self.getJobs();
  }

  getJobs() {
    let selectedRegionId = this.sessionStorageService.getItem("location-selectedRegionId");
    if(selectedRegionId) {
      this.selectedRegionId = selectedRegionId;
    }
    else {
      this.selectedRegionId = null;
    }
    let selectedDepotId = this.sessionStorageService.getItem("location-selectedDepotId");
    if(selectedDepotId) {
      this.selectedDepotId = selectedDepotId;
    }
    else {
      this.selectedDepotId = null;
    }

    let selectedLocationId = this.sessionStorageService.getItem("location-selectedLocationId");
    if(selectedLocationId) {
      this.selectedLocationId = selectedLocationId;
    }
    else {
      this.selectedLocationId = null;
    }

    this.jobService.getJobs(
        this.customerId,
        this.getLocationId(selectedLocationId),
        this.getDepotId(selectedDepotId),
        this.getRegionId(selectedRegionId),
        this.jobsPage,
        10)
      .subscribe(data => {
        this.jobs = data.jobs;
        this.jobsPaging = new PagingModel(data.currentPage, data.hasNext, data.hasPrevious, data.pageSize, data.totalPages, data.totalItemCount);
      }, error => {
        debugger;
      });
  }
  
  getLocation(locationId: string) : CustomerLocationDto{
    return this.locations.find(a => a.id == locationId);
  }

  showAssets() {
    let selectedAssetLocationTypeId = this.sessionStorageService.getItem("location-selectedAssetLocationTypeId");
    let selectedRegionId = this.sessionStorageService.getItem("location-selectedRegionId");
    if(selectedRegionId) {
      this.selectedRegionId = selectedRegionId;
    }    
    let selectedDepotId = this.sessionStorageService.getItem("location-selectedDepotId");
    if(selectedDepotId) {
      this.selectedDepotId = selectedDepotId;
    }
    let selectedVehicleType = this.sessionStorageService.getItem("dashboard-active-selectedVehicleType");
    if(selectedVehicleType) {
      selectedVehicleType = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedVehicleType"));
      this.selectedVehicleType = selectedVehicleType;
    }

    this.totalDepot = this.data.depotTotal;
    this.totalYard = this.data.yardTotal;
    this.totalDamaged = this.data.damagedTotal;
    this.totalAvailable = this.data.availableTotal;
    this.totalRequired = this.data.requiredTotal;
    this.totalSurplus = this.data.surplusTotal;
    this.totalDeficit = this.data.deficitTotal;
    this.totalNetSurplus = this.data.netSurplusTotal;
    this.summaryData = this.getSummaryData();
  }

  getSummaryData(): SummaryDataItemModel[] {
    let items = [];

    let depot: SummaryDataItemModel = {
      Title: "Depot" + (this.currentFilter == "Depot" && this.location ? ' *' : ''),
      Value: this.totalDepot.toString(),
      OnClick: () => this.filterContainers("Depot")
    };
    items.push(depot);

    let yard: SummaryDataItemModel = {
      Title: "Yard" + (this.currentFilter == "Yard" && this.location ? ' *' : ''),
      Value: this.totalYard.toString(),
      OnClick: () => this.filterContainers("Yard")
    };
    items.push(yard);

    let damaged: SummaryDataItemModel = {
      Title: "Damaged" + (this.currentFilter == "Damaged" && this.location ? ' *' : ''),
      Value: this.totalDamaged.toString(),
      OnClick: () => this.filterContainers("Damaged")
    };
    items.push(damaged);

    let available: SummaryDataItemModel = {
      Title: "Available" + (this.currentFilter == "Available" && this.location ? ' *' : ''),
      Value: this.totalAvailable.toString(),
      OnClick: () => this.filterContainers("Available")
    };
    items.push(available);

    if (!this.selectedDamageStatus) {
      let required: SummaryDataItemModel = {
        Title: "Required",
        Value: this.totalRequired.toString()
      };
      items.push(required);
  
      let netSurplus: SummaryDataItemModel = {
        Title: "Surplus",
        Value: this.totalNetSurplus.toString()
      };
      items.push(netSurplus);
    }

    return items;
  }

  filterContainers(filter: string) {
    this.currentFilter = filter;
    this.getContainers();
    this.summaryData = this.getSummaryData();
  }

  getRegionId(selectedRegionId) {
    if (!selectedRegionId) {
      return null;
    }

    return selectedRegionId;
  }

  getDepotId(selectedDepotId) {
    if (!selectedDepotId) {
      return null;
    }

    return selectedDepotId;
  }

  getLocationId(selectedLocationId) {
    if (!selectedLocationId) {
      return null;
    }

    return selectedLocationId;
  }

  getDamageStatus(selectedDamageStatus: string) {
    if (!selectedDamageStatus) {
      return null;
    }

    if (selectedDamageStatus == DamageStatus[DamageStatus.Damaged]) {
      return ContainerStatus.Damaged;
    }

    if (selectedDamageStatus == DamageStatus[DamageStatus.DamagedInService]) {
      return ContainerStatus.DamagedInService;
    }

    return ContainerStatus.InService;
  }

  getShowSetting(selectedShowSetting: string) {
    if (!selectedShowSetting) {
      return ContainerAvailabilityShow.All;
    }

    if (selectedShowSetting == ShowSetting[ShowSetting.Surplus]) {
      return ContainerAvailabilityShow.Surplus;
    }

    return ContainerAvailabilityShow.Deficit;
  }  

  getAssetTypeClassification(selectedVehicleType: string) {
    return !selectedVehicleType ? AssetTypeClassification.All : VehicleTypeHelper.ConvertVehicleTypeNameToAssetTypeClassification(selectedVehicleType)
  }

  regionChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("location-selectedRegionId", newValue);
    }
    else {
      this.sessionStorageService.removeItem("location-selectedRegionId");
    }

    this.selectedDepotId = null;
    this.sessionStorageService.removeItem("location-selectedDepotId");    
    this.getData();
  }

  depotChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("location-selectedDepotId", newValue);
    }
    else {
      this.sessionStorageService.removeItem("location-selectedDepotId");
    }

    this.getData();
  }

 locationChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("location-selectedLocationId", newValue);
    }
    else {
      this.sessionStorageService.removeItem("location-selectedLocationId");
    }

    this.getData();
  }

  damageStatusChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("location-selectedDamageStatus", newValue);
    }
    else {
      this.sessionStorageService.removeItem("location-selectedDamageStatus")
    }

    this.getData();
  }

 showSettingChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("location-selectedShowSetting", newValue);
    }
    else {
      this.sessionStorageService.removeItem("location-selectedShowSetting")
    }

    this.damageStatusChange("");
  }  

  selectedVehicleTypeValueChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("dashboard-active-selectedVehicleType", JSON.stringify(newValue));
    }
    else {
      this.sessionStorageService.removeItem("dashboard-active-selectedVehicleType");
    }

    this.selectedVehicleType = newValue;
    this.getData();    
  }

  toggleRow(category) {
    if (this.expandedCategories.includes(category)) {
      const index = this.expandedCategories.indexOf(category);
      if (index > -1) {
        this.expandedCategories.splice(index, 1);
      }
    } else {
      this.expandedCategories.push(category);
    }
  }
}